import { render, staticRenderFns } from "./AddEmailToBlacklistModal.vue?vue&type=template&id=0b3c97e3"
import script from "./AddEmailToBlacklistModal.vue?vue&type=script&lang=js"
export * from "./AddEmailToBlacklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports